// extracted by mini-css-extract-plugin
module.exports = {"container":"Map_container__1NXfc","isMobile":"Map_isMobile__3PxI1","icon":"Map_icon__jFn3m"};